import React, { memo } from "react";
import * as PropTypes from "prop-types";
import { methods } from "../../../constants";
import { withStyles } from "@material-ui/core";
import styleConstants from "../../../styleConstants";
import PanelChart from "../../chart/PanelChart";
import SmallLineChart from "../../chart/SmallLineChart";

const styles = {
  smallLineChart: {
    padding: "0 5px",
    border: "0px solid #eee"
  }
};

const ChangeByMethodChart = props => {
  const data = props.data;

  const yearData = data.filter(datum => !isNaN(datum.year));

  const maximumValue = Math.max(...yearData.map(datum => datum.value));

  return (
    <PanelChart>
      {methods.map((method, index) => {
        const series = {
          name: method,
          color: styleConstants.categoryColors.methodColors[method],
          data: yearData
            .filter(datum => datum.method === method)
            .map(datum => ({
              ...datum,
              year: parseInt(datum.year, 10)
            }))
            .sort((a, b) => a.year - b.year)
            .map(datum => [datum.year, datum.value])
        };

        return (
          <SmallLineChart
            key={method}
            title={method}
            marginLeft={index === 0 ? 60 : 0}
            width={index === 0 ? 160 : 100}
            yAxis={{
              title: index === 0 ? props.yAxisTitle : undefined,
              minimum: 0,
              maximum: maximumValue,
              showLabels: index === 0
            }}
            series={[series]}
            tooltipFormatter={props.tooltipFormatter}
            className={props.classes.smallLineChart}
            onRegisterChartRef={ref => {
              props.onRegisterChartRef(index, ref);
            }}
          />
        );
      })}
    </PanelChart>
  );
};

ChangeByMethodChart.propTypes = {
  data: PropTypes.array.isRequired,
  yAxisTitle: PropTypes.string,
  tooltipFormatter: PropTypes.func,
  onRegisterChartRef: PropTypes.func.isRequired
};

export default memo(withStyles(styles)(ChangeByMethodChart));
